import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { UtilitaService } from 'src/app/services/utilita.service';
import { AuthService } from 'src/app/services/auth.service';

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
 

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  router: any;
  msg = '';
  constructor(private srvUtilita: UtilitaService, private dialog: MatDialog,
    private routes: Router, public authService: AuthService) { }

  check(uname: string, p: string) {
    const objLog = {
      username: uname,
      password: p
    }
    this.authService.SignIn(uname, p);


  }

  eventHandler(event: any, uname: any, p: any) {
    if (event.keyCode == 13) {
      this.check(uname, p);
    }
  }

  ngOnInit() {

    localStorage.removeItem('usernameLogin')
    localStorage.removeItem('usernameUtente')
    localStorage.removeItem('username')

    localStorage.removeItem('CodiceNazione')
    localStorage.removeItem('idUtenteLogin')
    localStorage.removeItem('IDUtente')
    localStorage.removeItem('CodiceLogin')
    localStorage.removeItem('CodiceUtente')
    localStorage.removeItem('StatoLogin')
    localStorage.removeItem('StatoUtente')
    localStorage.removeItem('CodiceStatoLogin')
    localStorage.removeItem('CodiceStatoUtente')
    localStorage.removeItem('Listino')
    localStorage.removeItem('ListinoUtente')
    localStorage.removeItem('Tipo')
    localStorage.removeItem('TipoUtente')
    localStorage.removeItem('CodiceLingua')
    localStorage.removeItem('NominativoLogin')
    localStorage.removeItem('NominativoUtente')

    AuthService.loggedIn = false;

  }

  btnRecuperaPassword() {
    this.routes.navigate(['/recupera-password']);

  }

}
